import { Injectable } from '@angular/core';
import { MenuItem } from '../types/others/menu-item';

@Injectable({
  providedIn: 'root',
})
export class DatastoreService {
  /**
   * Dependancy Injection of Services here.
   */
  constructor() {}

  /**
   * Declare and initialize the menu item as the routes
   */
  public menuItems: Array<MenuItem> = [
    {
      title: 'Coupon Performance',
      route: '/coupon-performance',
      icon: './assets/media/icons/duotune/ecommerce/ecm011.svg',
      routerLinkActiveOptions: { exact: true },
      children: [],
    },
    {
      title: 'Upsell Rates',
      route: '/upsell-rates',
      icon: './assets/media/icons/duotune/graphs/gra012.svg',
      routerLinkActiveOptions: { exact: false },
      children: [],
    },
    {
      title: 'Pet Demographics',
      route: '/pet-demographics',
      icon: './assets/media/icons/duotune/graphs/gra004.svg',
      routerLinkActiveOptions: { exact: false },
      children: [],
    },
    {
      title: 'Shipments Report',
      route: '/shipments-report',
      icon: './assets/media/icons/duotune/graphs/gra003.svg',
      routerLinkActiveOptions: { exact: false },
      children: []
    }
  ];

  public footerItems: Array<MenuItem> = [
    {
      title: 'Support',
      route: '/support',
      icon: './assets/media/icons/duotune/abstract/abs035.svg',
      routerLinkActiveOptions: { exact: true },
      children: [],
    },
  ];
}
